<template>
	<div ref="pdfContainer" class="pdf-js-container" v-on:click="$emit('click')">
		<!--<canvas ref="pdfJsCanvas"></canvas>-->
	</div>
</template>
<style type="text/css">
	.pdf-js-container canvas {
		max-width: 100%;
		box-shadow: 0 5px 10px 0px grey;
		margin-bottom: 10px;
	}
</style>
<script type="text/javascript">
export default {
	name: "PdfJs",
	props: ["url","page"],
	data() {
		return {
			numPages: 1,
			thePdf: null,
			scale: 1
		}
	},
	watch: {
		url() {	
			this.render()
		},
		page() {
			this.render()
		}
	},
	methods: {
		renderPage(pageNum,canvas) {
			let vm = this

			this.thePdf.getPage(pageNum).then(function(page) {

				let container = vm.$refs.pdfContainer

				let desiredWidth = container.offsetWidth

				let viewport = page.getViewport({scale:vm.scale})

				let scale = desiredWidth / viewport.width
				let scaledViewport = page.getViewport({scale:scale})

				canvas.height = scaledViewport.height
				canvas.width = scaledViewport.width    
				page.render({canvasContext: canvas.getContext('2d'), viewport: scaledViewport})
			})
		},
		render() {
			let vm = this
			if (this.url && typeof pdfjsLib != 'undefined') {
				pdfjsLib.getDocument(this.url).promise.then(pdf => {

					vm.numPages = pdf.numPages
					vm.thePdf = pdf

					let container = vm.$refs.pdfContainer

					container.innerHTML = ""

					for (var page = 1; page <= vm.numPages; page++) {
						let canvas = document.createElement("canvas")
						canvas.className = 'pdf-page-canvas'
						container.appendChild(canvas)
						vm.renderPage(page, canvas);
					}
				})
			}
		}
	},
	created() {
		let s = document.createElement('script');
		s.type = "text/javascript"
		s.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.2.2/pdf.min.js'

		document.head.appendChild(s);
	},
	mounted() {
		let vm = this

		let scriptLoadedChecker = setInterval(() => {
			if (typeof pdfjsLib != 'undefined') {
				vm.render()
				clearInterval(scriptLoadedChecker)
			}
		},200)
	}
}
</script>